import { render, staticRenderFns } from "./ComissionsTerms.vue?vue&type=template&id=4c448c4b&scoped=true&"
import script from "./ComissionsTerms.vue?vue&type=script&lang=js&"
export * from "./ComissionsTerms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c448c4b",
  null
  
)

export default component.exports